import styled from 'styled-components';
import { OverflowMenu } from 'ui/actionMenu';
import { BulkActionsBar } from 'ui/bulkActionsBar';
import { spacing } from 'ui/theme';

export const SearchWrapper = styled.div`
  min-width: ${spacing.x16};
`;

export const Actions = styled(OverflowMenu)`
  grid-area: actions;
  justify-self: flex-end;
`;

export const StyledBulkActionsBar = styled(BulkActionsBar)`
  height: auto;
`;

export const TableActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
  margin-bottom: ${spacing.plusQuarter};

  &[data-mode='edit'] {
    gap: ${spacing.half};
    margin-bottom: 0;
  }
`;

export const TableActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.half};
`;

export const FieldLockStateWrapper = styled.div`
  margin-right: auto;
`;
